export interface AuthScopeBase {
  mappings: Partial<Record<AvengersRole, CrudOp[]>>;
  type: DifferentiationType;
}

export interface BrandDifferentiatedAuthScope extends AuthScopeBase {
  type: DifferentiationType.BRAND;
}

export interface ProjectDifferentiatedAuthScope extends AuthScopeBase {
  type: DifferentiationType.PROJECT;
}

export interface UndifferentiatedAuthScope extends AuthScopeBase {
  type: DifferentiationType.NONE;
}

export enum DifferentiationType {
  BRAND = "BRAND",
  PROJECT = "PROJECT",
  NONE = "NONE",
}

export enum AvengersRole {
  ADMIN = "ADMIN",
  PROJECT_MANAGER = "PROJECT_MANAGER",
  OPERATOR = "OPERATOR",
  LIBRARY_OPERATOR = "LIBRARY_OPERATOR",
  OPERATOR_EDITORIAL = "OPERATOR_EDITORIAL",
  READER = "READER",
}

export enum CrudOp {
  CREATE = "CREATE",
  READ = "READ",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
}
